module.exports = __webpack_public_path__ + "static/media/briefcase-medical.486bb528.svg";